import styles from './SectionContainer.module.scss'
import { cloneElement, useRef } from 'react'
import { buildIdFromText } from '@/utils'

const SectionContainer = ({
  _type,
  children,
  cmsTitle,
  sectionsLength,
  sectionBackground,
  nextSectionBackground,
  previousSectionBackground,
  nextSectionType,
  sectionIndex,
}: SectionContainerProps) => {
  const containerRef = useRef<HTMLElement>(null)
  const id = buildIdFromText(cmsTitle)

  const newElement = cloneElement(children, {
    sectionId: id,
    sectionBackground,
    sectionIndex,
  })

  return (
    <section
      id={id}
      ref={containerRef}
      data-component={_type}
      className={styles.SectionContainer}
      data-sections-length={sectionsLength}
      data-section-background={sectionBackground}
      data-section-background-previous={previousSectionBackground}
      data-section-background-next={nextSectionBackground}
      data-section-next-section-type={nextSectionType}
    >
      {newElement}
    </section>
  )
}

SectionContainer.displayName = 'SectionContainer'

export default SectionContainer
